import { Button } from "@/components/ui/button";
import { Shield, X } from "lucide-react";

export default function ImpersonationBanner({ user, onExit }) {
  if (!user) return null;
  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-black py-2 px-4 flex items-center justify-center gap-4 text-sm font-semibold shadow-lg"
      data-testid="impersonation-banner"
    >
      <Shield className="w-4 h-4" />
      <span>
        Modo de visualizacion: Viendo como <strong>{user?.name || user?.email}</strong> ({user?.role})
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 bg-black/20 border-black/30 text-black hover:bg-black/30 font-semibold"
        onClick={onExit}
        data-testid="exit-impersonation-btn"
      >
        <X className="w-3 h-3 mr-1" /> Salir
      </Button>
    </div>
  );
}
